document.addEventListener('DOMContentLoaded', function() {

    // defaults options DATATABLE
    $.extend($.fn.dataTable.defaults, {
        responsive: {
            details: {
                renderer: function (api, rowIdx, columns) {
                    var data = $.map(columns, function (col, i) {
                        return col.hidden ?
                            '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
                            '<td>' + col.title + ':' + '</td> ' +
                            '<td>' + col.data + '</td>' +
                            '</tr>' :
                            '';
                    }).join('');

                    return data ?
                        $('<table/>').append(data) :
                        false;
                }
            }
        },
        language : {
            search: "Rechercher&nbsp;:",
            loadingRecords: "Chargement en cours...",
            zeroRecords: "Aucun &eacute;l&eacute;ment &agrave; afficher",
            emptyTable: "Aucun résultat",
            paginate: {
                first: "<i class=\"fas fa-angle-double-left\"></i>",
                previous: "<i class=\"fas fa-angle-left\"></i>",
                next: "<i class=\"fas fa-angle-right\"></i>",
                last: "<i class=\"fas fa-angle-double-right\"></i>"
            },
            info: "Affichage des l'&eacute;l&eacute;ments _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments",
            infoEmpty: "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment",
            lengthMenu: "Afficher _MENU_ lignes"
        },
        dom :'<t><r><"row pt-3"<"col-sm-6"l><"col-sm-6"p>>'
    })


})